import { useState, useEffect, useCallback } from "react";
import { API, useAuth } from "@/App";
import axios from "axios";
import { NewsletterComposer } from "./newsletter/NewsletterComposer";
import { toast } from "sonner";

export const SubscribersManagement = () => {
  const { token } = useAuth();
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSubscribers = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/admin/subscribers`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSubscribers(response.data);
    } catch (error) {
      toast.error("Failed to load subscribers");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchSubscribers();
  }, [fetchSubscribers]);

  return (
    <div data-testid="admin-subscribers">
      <h1 className="font-heading text-3xl text-charcoal mb-2">Newsletter Subscribers</h1>
      <p className="font-body text-stone-grey mb-8">Manage subscribers and send newsletters</p>

      <div className="grid grid-cols-1 xl:grid-cols-5 gap-8">
        <div className="glass rounded-xl p-6 xl:col-span-2">
          <h2 className="font-heading text-xl text-charcoal mb-4">Active Subscribers ({subscribers.length})</h2>
          {loading ? (
            <div className="flex justify-center py-8"><div className="spinner" /></div>
          ) : subscribers.length === 0 ? (
            <p className="font-body text-stone-grey text-center py-8">No subscribers yet</p>
          ) : (
            <div className="max-h-96 overflow-y-auto space-y-2">
              {subscribers.map((sub) => (
                <div key={sub.id} className="flex items-center justify-between p-3 bg-sand/30 rounded-lg">
                  <div>
                    <p className="font-body text-sm text-charcoal">{sub.email}</p>
                    {sub.name && <p className="font-body text-xs text-taupe">{sub.name}</p>}
                  </div>
                  <span className="font-body text-xs text-taupe">{new Date(sub.subscribed_at).toLocaleDateString()}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="xl:col-span-3"><NewsletterComposer subscriberCount={subscribers.length} /></div>
      </div>
    </div>
  );
};

